var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-loading',{attrs:{"is-full-page":true,"can-cancel":false},model:{value:(_vm.showIsLoading),callback:function ($$v) {_vm.showIsLoading=$$v},expression:"showIsLoading"}})}
var staticRenderFns = []

export { render, staticRenderFns }